import { getLocalVar, setLocalVar } from '@/libs/Util.js'

export default {
    state: {
        flags: ['es', 'en', 'pt'],
        selectedLanguage: getLocalVar('selectedLanguage') || 'pt'
    },
    mutations: {
        setSelectedLanguage (state, flag) {
            setLocalVar('selectedLanguage', flag)
            state.selectedLanguage = flag
        }
    },
    actions: {
        selectLanguage ({ commit }, flag) {
            commit('setSelectedLanguage', flag)
        }
    },
    getters: {
        selectedLanguage: (state) => state.selectedLanguage,
        flags: (state) => state.flags
    }
}
